module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [(!_vm.blockList.length) ? _c('div', {
    staticClass: "box-body"
  }, [_vm._v("\n    無選擇區，請新增\n  ")]) : _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_vm._m(0), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger inline-block m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#delModal"
    },
    on: {
      "click": _vm.delModalOpen
    }
  }, [_vm._v("\n          刪除\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right",
    on: {
      "click": _vm.gotoCrBlocks
    }
  }, [_vm._v("\n          新增\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-black btn-default inline-block m-r-10 m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.show.easy = !_vm.show.easy
      }
    }
  }, [(!_vm.show.easy) ? _c('span', [_vm._v("簡易")]) : _c('span', [_vm._v("進階")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary m-r-10 m-y-10 pull-right",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseModal"
    },
    on: {
      "click": function($event) {
        return _vm.clearAllActive(_vm.blockChoseList)
      }
    }
  }, [_vm._v("\n          複製商品到其他選擇區\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    ref: "selectBlock",
    staticClass: "bg-light-gray col-md-2 col-xs-12 select-element-block text-left"
  }, _vm._l((_vm.blockList), function(block, index) {
    return _c('div', {
      key: block.item_id,
      staticClass: "select-element",
      class: {
        'active': _vm.curId === block.item_id
      },
      attrs: {
        "disabled": _vm.isLoad || _vm.curId === block.item_id
      },
      on: {
        "click": function () { return _vm.clickBlock(block, index); }
      }
    }, [_c('span', {
      staticClass: "text-w-600"
    }, [_vm._v(_vm._s(block.name))]), _vm._v(" "), _c('small', {
      staticStyle: {
        "opacity": ".7"
      }
    }, [_vm._v("  " + _vm._s(block.remark))])])
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoad),
      expression: "!isLoad"
    }],
    staticClass: "col-md-10 col-xs-12"
  }, [_c('div', {
    staticClass: "box-body col-xs-12 form menu-form"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12 p-r-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.name),
      expression: "blockInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "32"
    },
    domProps: {
      "value": (_vm.blockInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.sort),
      expression: "blockInfo.sort"
    }],
    ref: "sort1",
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.blockInfo.sort)
    },
    on: {
      "keyup": _vm.veritySort,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "sort", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "h-38 radio text-left",
    staticStyle: {
      "border-left": "1px solid #d2d6de"
    }
  }, [_c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.is_mandatory),
      expression: "blockInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.blockInfo.is_mandatory, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.blockInfo, "is_mandatory", 1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("是")])]), _vm._v(" "), _c('label', {
    staticClass: "m-l-15"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.is_mandatory),
      expression: "blockInfo.is_mandatory"
    }],
    staticStyle: {
      "top": "12px"
    },
    attrs: {
      "type": "radio",
      "name": "mandatoryRadio"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.blockInfo.is_mandatory, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.blockInfo, "is_mandatory", 0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "top": "8px",
      "left": "8px"
    }
  }, [_vm._v("否")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.min_limit),
      expression: "blockInfo.min_limit"
    }],
    ref: "minLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.blockInfo.min_limit)
    },
    on: {
      "keyup": _vm.verityMinLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "min_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "line-height": "38px",
      "width": "20px"
    }
  }, [_vm._v("~")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.max_limit),
      expression: "blockInfo.max_limit"
    }],
    ref: "maxLimit",
    staticClass: "c-auto form-control",
    staticStyle: {
      "width": "calc(50% - 10px)"
    },
    attrs: {
      "placeholder": "0為無上限",
      "type": "text",
      "maxlength": "9"
    },
    domProps: {
      "value": (_vm.blockInfo.max_limit)
    },
    on: {
      "keyup": _vm.verityMaxLimit,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "max_limit", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("備註")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.remark),
      expression: "blockInfo.remark"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.blockInfo.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "remark", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show.easy),
      expression: "!show.easy"
    }],
    staticClass: "col-md-6 col-xs-12 p-l-5"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("描述")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.description),
      expression: "blockInfo.description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.blockInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品料號")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.blockInfo.vendor_custom_id),
      expression: "blockInfo.vendor_custom_id"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "30"
    },
    domProps: {
      "value": (_vm.blockInfo.vendor_custom_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.blockInfo, "vendor_custom_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("商品")]), _vm._v(" "), _c('div', {
    staticClass: "form-control text-left",
    staticStyle: {
      "min-height": "60px"
    }
  }, [_c('button', {
    staticClass: "btn btn-black btn-default inline-block m-y-10",
    staticStyle: {
      "position": "absolute",
      "right": "10px",
      "top": "0px",
      "z-index": "3"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseProdModal"
    }
  }, [_vm._v("\n                  選擇商品\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "option-left-block"
  }, _vm._l((_vm.productList), function(prod) {
    return (prod.active) ? _c('div', {
      key: prod.item_id,
      staticClass: "inline-block m-r-10 option-chose",
      staticStyle: {
        "margin": "5px"
      }
    }, [_vm._v("\n                    " + _vm._s(prod.name) + "\n                  ")]) : _vm._e()
  }), 0)])]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.gotoOut
    }
  }, [_vm._v("\n      返回\n    ")]), _vm._v(" "), (!_vm.blockList.length) ? _c('button', {
    staticClass: "btn btn-black btn-default",
    on: {
      "click": _vm.gotoCrBlocks
    }
  }, [_vm._v("\n      新增\n    ")]) : _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.checkInputEmpty
    }
  }, [_vm._v("\n      儲存\n    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('CModal', {
    attrs: {
      "element-list": _vm.productList,
      "option": _vm.choseProduct,
      "show-money": true
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('CModal', {
    attrs: {
      "element-list": _vm.blockChoseListWithoutCurrent,
      "option": _vm.choseOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('MModal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.delOption
    },
    on: {
      "trigger": _vm.trigger
    }
  }), _vm._v(" "), _c('PIModal', {
    attrs: {
      "hide-cancel": true,
      "product-list": _vm.productList,
      "option": _vm.moneyOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inline-block pull-left"
  }, [_c('h4', {
    staticClass: "pull-left"
  }, [_vm._v("\n          品項選擇區\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("品項選擇區名稱")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("排序")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("必選項目")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("\n\n                選購數量"), _c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("套餐內的商品")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default form-control",
    staticStyle: {
      "width": "auto"
    },
    attrs: {
      "data-toggle": "modal",
      "data-target": "#choseMoneyModal"
    }
  }, [_vm._v("\n                變更套餐內商品資訊\n              ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b9a266a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Menu/Temp/CrBlockTemp.vue
// module id = 2410
// module chunks = 1